import React from "react";
import "./Gallery.css";
import AboutS1P1BIcon from "../../Assets/Svg/AboutS1P1BIcon.svg";
import GalleryS3Com from "../../Components/GalleryS3/GalleryS3";
import CompanyCatalogue from "../../Assets/PDF/Company_Catalogue.pdf";
import ContactSection from "../../Components/ContactSection/ContactSection";

export default function GalleryArContent() {
  return (
    <>
      <GalleryS1 />
      <GalleryS2 />
      <GalleryS3 />
    </>
  );
}

function GalleryS1() {
  const isMobile = window.innerWidth <= 765;
  return (
    <div className="GalleryS1" dir="rtl">
      <div className="GalleryS1_P1 ar Cont">
        <h1>الفئات</h1>
        {isMobile ? (
          <>
            <div>
              <div className="GS1C">مرحبًا بكم في معرض الزيّ الرسمي في يونيفورم أرينا!</div>
              <div className="GS1C">اكتشفوا مجموعة من أفضل إبداعات الزيّ الرسمي، التي تجمع بين الجودة، والأسلوب، والمرونة في التصاميم</div>
            </div>
          </>
        ) : (
          <>
            <div>
              <div className="GS1C">مرحبًا بكم في معرض الزيّ الرسمي في يونيفورم أرينا!</div>
              <div className="GS1C">اكتشفوا مجموعة من أفضل إبداعات الزيّ الرسمي، التي تجمع بين الجودة،</div>
              <div className="GS1C">والأسلوب، والمرونة في التصاميم</div>
            </div>
          </>
        )}
      </div>
      <div className="GalleryS1_P1 ar GalleryS1_P1_Mob">
        <h3>تنزيل الكتيب الرقمي لعرض تشكيلاتنا من الزيّ الرسمي.</h3>
        <a href={CompanyCatalogue} download="Company_Catalogue.pdf" className="HomeS4_P1_A">
          <button className="GalleryS1_B ar">
            قم بتحميل الكتالوج
            <img src={AboutS1P1BIcon} alt="" />
          </button>
        </a>
      </div>
    </div>
  );
}

function GalleryS2() {
  return (
    <>
      <div className="GalleryS3Com">
        <div className="GalleryS3T ar">اختر المجال الخاص بك</div>
        <GalleryS3Com />
      </div>
    </>
  );
}

function GalleryS3() {
  return <ContactSection />;
}
